import { render, staticRenderFns } from "./CoreSnackbar.vue?vue&type=template&id=00cccb9c&scoped=true"
import script from "./CoreSnackbar.vue?vue&type=script&lang=js"
export * from "./CoreSnackbar.vue?vue&type=script&lang=js"
import style0 from "./CoreSnackbar.vue?vue&type=style&index=0&id=00cccb9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cccb9c",
  null
  
)

export default component.exports